module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "body"
  }, [_c('p', {
    staticClass: "sp1",
    attrs: {
      "id": "ch3"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "Chap-Number-cn"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_27",
      "title": "27"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/contents#c_ch3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("3")])])])]), _vm._v(" "), _c('p', {
    staticClass: "Chap-Title-ct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/contents#c_ch3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("Gamelan, My Little Doggie")]), _c('span', {
    staticClass: "ePub-B"
  }), _c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("…")])])]), _vm._v(" "), _c('p', {
    staticClass: "CO"
  }, [_vm._v("The smell of rain is an astounding thing. If you live inside the arid skin of "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Olympia,")]), _vm._v(" you may smell machines, blood, human sweat, that sort of thing. But the smell of rain is unlike anything you could imagine. Yet even if you’ve never smelled it before, you will know what it is.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("I stood in the rain of the Habitat Sector, waiting to serve the Executives at Baylor Charmayne’s garden party. They stood in the same rain. Precipitation on "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Olympia")]), _vm._v(" was so fine, it fell as a mist. Our clothing couldn’t absorb it; a Servant’s mantle covered our heads.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Some of the Executives wore their own version of mantles, but most of them let their hair get wet. They found the discomfort amusing, because they endured it so rarely and could end it at any time.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("This was near the end of my fourth year on the job, and I watched this behavior because I found it odd. I also took note of the moisture on my skin, the colors of the fresh vegetables, and the handsome face of Nuruddin, who was one of my coworkers. In his Servant’s mantle, he looked like an Egyptian king. But ancient art was not generally studied on "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Olympia")]), _vm._v(" at that time, so I was one of the few people who noticed that.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Despite these distractions, I remained focused on my duties. The Executives require Servants to respond to their slightest cue, to be at hand with whatever is required in an instant, whether that be a napkin, a dish, a refill of a beverage, or any one of a thousand other details. We’re like the Japanese Bunraku stage technicians who dress all in black, pretending to be part of the scenery; we must move silently, unobtrusively, and efficiently. Those of us who can’t, don’t make it out of training.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("My father hadn’t been happy when I told him my ambitions, though he did understand them. No tech training had materialized for me on "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Titania,")]), _vm._v(" and we hoped that "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Olympia")]), _vm._v(" might provide more opportunities for me, since I was sixteen and still trainable. But extensive modification is needed to become a Servant, and my forbidden implants could have been discovered at "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_28",
      "title": "28"
    }
  }, [_vm._v("any time during that process. My father had to pull a lot of strings to make sure the right med techs were on duty the cycles I went in for modification.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("I had passed through it easily. I even received artificial eyes as a bonus—I would be able to change the iris color at will. That pleased my vanity, but would also come in handy for special projects, later.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("I moved to Central Sector on "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Olympia.")]), _vm._v(" I had goals, both short-term and long-term. First, I wanted to move my parents to "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Olympia.")]), _vm._v(" But I didn’t do it soon enough.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("They were dead before I finished my first thirty cycles of work.")]), _vm._v(" "), _c('p', {
    staticClass: "SB_STD"
  }, [_vm._v("*   *   *")]), _vm._v(" "), _c('p', {
    staticClass: "SB1"
  }, [_vm._v("Four years later, we had left the wreckage of our sister ship far behind. Now Baylor Charmayne sat at the head of his clan’s table. He still talked about his mother, which was sad when you considered all the other people who had died on "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Titania.")]), _vm._v(" Sometimes he cried when he talked about her, though he wasn’t doing it tonight. He was in a fair mood, which was as good as it got with Baylor. He, the food, the table, and his guests were all visible. But I could not see the plants that I could smell. I could not hear the rain falling.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("We, his Servants, are beautiful. The Executives will tolerate nothing less. They are not so attractive as we, but they don’t know it. They seem enthralled with each other, and they never tire of arguing law or of playing at politics—not even at this supper. That’s why the Tedd clan sent a representative to the party, a cocky young upstart named Glen Tedd.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“A toast!” cried Tedd, which was our cue to fill their glasses. We performed like clockwork. “To Sheba Charmayne! Now, there was a tough negotiator. We’ll never see her like again. We Tedds thank God for that.” He grinned. “We’ve done very well since her "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("untimely")]), _vm._v(" demise.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("All eyes shifted to Baylor, who didn’t seem inclined to sip his drink.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Convenient that her escape shuttle was destroyed before she could use it.” Tedd winked at Baylor. “Otherwise, she would be sitting at the head of this table.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Baylor had no obvious reaction, but his gaze flicked to Ryan, who wasn’t so good at schooling his expression. Tedd was going to die for what he had just said.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("I wondered who else knew it. Ryan did, because it was his favorite sport. But I don’t think Tedd did. I think he believed his clan was too powerful to suffer those sorts of consequences. He drank his wine, and demanded more. The party continued its dreary pace.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("When the food and drink had been cleared from the table, Baylor and his "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_29",
      "title": "29"
    }
  }, [_vm._v("guests moved inside, leaving us to stand at our posts. A group of lower-level Executives came into the garden. They were all clan members, but they had only slightly more status than the bureaucrats working in "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Titania")]), _vm._v("’s skin. I recognized one of them, Terry Charmayne. Though I had never spoken to him, I knew something of his personal history. Recently, he had appeared at our staging area on a regular basis, and I assumed he had become a useful liaison between Baylor and Security.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("I watched him covertly. Ryan Charmayne thought of himself as a good-looking fellow, but Terry actually was. Like most of the people in his family, Terry had olive skin, black hair, and black eyes. He was slim and well toned, too. But if I were objective, I’d have to say that Terry’s good looks were partly a matter of demeanor. A face tends to be pleasant when the mind behind it is.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("In my case, that may be less true.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Some of the less-favored Charmaynes resented the fact that they weren’t invited to the fancy dinner, but I couldn’t tell whether Terry felt that way. They stood for quite a long while before Terry decided they should move out of the rain and onto one of the covered patios not being used by the elite. They left us alone.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("We stood patiently. All of us were experts at waiting. To entertain myself, I played gamelan music in my head: slow, courtly pieces for orchestras of gongs and cymbals. It seemed to fit the scene, and I found it entertaining. But as the minutes slipped by, and no one dismissed us, an idea began to form in my head. Those flowers I had always longed to see were just a meter away. I still couldn’t see them, but I could smell them.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("I took a slow step toward them. No one reacted. I took another. Altogether, it was four steps until I was no longer standing on the paving.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("I knelt and reached blindly. My hands encountered something soft and fuzzy. I explored further and found the ground—the fuzzy things were growing out of the soil, so this was a plant I was touching. It was not at all what I expected a plant to feel like, with big, soft lobes and a central stalk that had clusters of other fuzzy things near the top.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("I leaned over and smelled the stalk. It wasn’t perfumed like the flowers in Baylor Charmayne’s vases, but the aroma was pleasant.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Someone kicked me in the butt, not hard enough to hurt me, but firmly enough to get my attention. I looked over my shoulder and saw Terry Charmayne. “What do you think you’re doing?” he said. “If someone sees you doing that, you could get terminated.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Terminated")]), _vm._v(" was an interesting word. I had a feeling he didn’t mean "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("fired.")]), _vm._v(" Yet his tone was not unkind.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_30",
      "title": "30"
    }
  }, [_vm._v("“Don’t get curious,” he said. “Just do your job and you’ll be all right.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("I stood and let my hands fall passively. “Yes, sir,” I said in the Girl Friday voice.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("One side of his mouth quirked in a sort-of smile. “Come on. I’ll escort you to the Security lock. You may as well call it a day.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("He led the way, so we all fell in behind him. I was able to study him more closely as we walked along. His clothing wasn’t that fancy, and the superiority was almost completely absent from his demeanor. He was a midlevel Executive from a powerful family, yet he acted more like a Ship Officer. He saw us to the lock, waiting until he was sure we were safely through, then gave me a brisk, “Pleasant rest.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Yes, sir.” I didn’t look back. Instead, I searched the networks for Terry Charmayne’s recent footprints. He may become useful someday.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("The other Servants walked quickly, eager to be done with their day and reclaim what they could of their senses. But Nuruddin slowed his pace until he was walking beside me. “What did it smell like?” he rasped in what was left of his real voice.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("I had to think about it. “It smelled—green.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Like tea?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Very much, yes, but—stronger than that. It was pungent. It was a living thing.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Is that why you risked so much to smell it?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Yes.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Nuruddin was silent for a long moment. Then he said, “You are braver than I, Oichi. But you are no more curious.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("We kept pace in companionable silence, until the others had disappeared ahead of us. I hoped Nuruddin was enjoying my company, but for my part, I was pondering the wisdom of asking him questions. Questioning someone can be an adequate method of gathering information, but they may ask you questions in return. Nuruddin had already warned me of his curiosity.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Before I could reach a conclusion, someone pulled the plug on our senses.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("I could see nothing but white void. My hearing was gone, too, without even the ringing that accompanies natural silence. I probed for a surveillance camera and linked with it. Nuruddin and I stood in the tunnel with two Executive boys who could not be more than twelve years old. They had eliminated themselves from our audio and visual feeds so we wouldn’t know they were there. I hadn’t smelled them at first, because the ventilation had blown their scent away from us, but now that they were close, my nose detected an "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_31",
      "title": "31"
    }
  }, [_vm._v("undertone in their sweat that raised the hair on the back of my neck. They both held knives, and they grinned at Nuruddin, nudging each other as if to say, "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("I dare you to do it.")]), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("…")])])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Nuruddin’s face was calm, but I could see concern trying to surface through the strict muscle controls that we Servants must endure to keep our demeanors serene. He must be wondering why our senses were being blocked. I doubted he would guess the truth until he felt the first slice. I would have to take him to the hospital once they let us go.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“I’m going to cut his lips off.” The boy giggled. “And then I’m going to cut his nose off.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("So "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("no.")]), _vm._v(" Nuruddin would not be able to recover from this assault with some minor medical attention. I would have to intervene.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("The order would have to originate from someplace outside the normal grid. I searched desperately, my mind racing along the network.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("And suddenly I found an unknown pathway. I used it to trigger the alarm.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Our hearing and eyesight returned as the klaxons sounded. “"), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("ATTENTION")]), _vm._v(",” warned a gigantic voice, “"), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("EXPLOSIVE")]), _vm._v(" "), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("DECOMPRESSION")]), _vm._v(" "), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("IS")]), _vm._v(" "), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("IMMINENT.")]), _vm._v(" "), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("ALL")]), _vm._v(" "), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("PERSONNEL")]), _vm._v(" "), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("MUST")]), _vm._v(" "), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("EVACUATE")]), _vm._v(" "), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("TUNNEL")]), _vm._v(" "), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("H")]), _vm._v("17 "), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("IMMEDIATELY.")]), _vm._v(" "), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("REPEAT")]), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("…")]), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("”")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("The two boys jumped as if they had received electric shocks when they lost control of our sensory feed. They forgot they were Executives facing Servants, and they raced away—though not before Nuruddin saw the knives they were brandishing. As soon as they were gone, the alarm cut off, along with the warning voice.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Nuruddin stared at me, his face stiff with shock. “Explosive decompression?” he croaked. “Is that even possible, this far in?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("I shrugged. “I guess it would be if something catastrophic happened.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Like "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("what")]), _vm._v("?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“I don’t want to imagine it.” Unfortunately, I didn’t have to imagine, because I had seen fragmented Security footage of what had happened on "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Titania.")]), _vm._v(" “Anyway, it seems to have been a glitch.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“In the future,” he said, “I guess we’d better stick with the others so we’re not in here alone.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("I nodded, and the two of us hurried down the final stretch of corridor to our staging area.")]), _vm._v(" "), _c('p', {
    staticClass: "SB_STD"
  }, [_vm._v("*   *   *")]), _vm._v(" "), _c('p', {
    staticClass: "SB1"
  }, [_vm._v("Servants are not allowed to socialize with each other when we’re off duty. I went back to my quarters without seeing or speaking to a soul. I bathed, sipped "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_32",
      "title": "32"
    }
  }, [_vm._v("nutrient broth, and bundled myself into my cubby. I had hoped to listen to more gamelan music, but I couldn’t stop thinking about the remark Glen Tedd had made at supper.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Convenient that her escape shuttle was destroyed before she could use it.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Sheba Charmayne didn’t make it off "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Titania.")]), _vm._v(" But like everyone else, I had assumed that disaster overtook her on the way to her escape shuttle. I never thought it had been sabotaged.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("True, I knew she and Baylor despised worms. When "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Titania")]), _vm._v(" was destroyed, I suspected the two of them. I had even overheard some of their plotting, through my secret link. But I was still a child then, and what they had said at the time didn’t make much sense to me. So instead of trying to figure it out, I recorded it.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("I still had the recording. I had never replayed it, because I never heard them overtly say they were going to blow "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Titania")]), _vm._v(" up. What was it they had said?")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("How do we kill them before they figure out what we’re up to?")]), _vm._v(" Sheba had asked. That was what got me to start listening.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("But Baylor’s answer didn’t make sense. "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Couldn’t we just dismantle them? Use their components for something useful?")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Dismantle?")]), _vm._v(" I thought. "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Components?")]), _vm._v(" It sounded as though they were talking about machines. But why would you talk about killing machines?")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("They’re too complex for that,")]), _vm._v(" said Sheba, managing to sound impatient, even though she wasn’t using her throat to speak. "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Too sophisticated. They have a self-defense system, and they would suspect what we were up to. No—if we want to destroy them, they can’t appear to be our main targets. They can’t appear to be our targets at all.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Back then, this was the point in their conversation when I began to lose interest. Their discussions had turned to inventories of supplies, energy consumption and production, that sort of thing. But now I realized they were talking about "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Titania")]), _vm._v("’s statistics in a particular sort of way; they were debating whether they could afford to sacrifice her, even though they never specifically "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("said")]), _vm._v(" they were going to do that. These stats were incomplete, too, as if they had discussed them many times and no longer had the patience to go over them in detail. Amazingly, I almost lost interest again, almost stopped listening.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("But then Sheba said,… "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("their pathway is not part of the known network.")]), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("…")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("When I triggered the alarm that saved Nuruddin, I had discovered a pathway outside the normal network. Now I had time to explore it and figure out "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_33",
      "title": "33"
    }
  }, [_vm._v("what it was. I reached for it again, but it wasn’t the same this time. A new link had appeared on it.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("The link had no name. I touched it anyway.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_c('span', {
    staticClass: "span-symbols-sym"
  }, [_vm._v("<")]), _vm._v("Awake,"), _c('span', {
    staticClass: "span-symbols-sym"
  }, [_vm._v(">")]), _vm._v(" said a voice in my head. "), _c('span', {
    staticClass: "span-symbols-sym"
  }, [_vm._v("<")]), _vm._v("Orders?"), _c('span', {
    staticClass: "span-symbols-sym"
  }, [_vm._v(">")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("I was flummoxed. I hadn’t rung the link, I had simply touched it—and now someone was talking to me.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_c('span', {
    staticClass: "span-symbols-sym"
  }, [_vm._v("<")]), _vm._v("Orders?"), _c('span', {
    staticClass: "span-symbols-sym"
  }, [_vm._v(">")]), _vm._v(" repeated the voice, with relentless patience.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("I tried to disengage from the link, but I couldn’t. I felt alarmed. I couldn’t just struggle; I needed to take action.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_c('span', {
    staticClass: "span-symbols-sym"
  }, [_vm._v("<")]), _vm._v("Who are you?"), _c('span', {
    staticClass: "span-symbols-sym"
  }, [_vm._v(">")]), _vm._v(" I asked.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_c('span', {
    staticClass: "span-symbols-sym"
  }, [_vm._v("<")]), _vm._v("Medusa,"), _c('span', {
    staticClass: "span-symbols-sym"
  }, [_vm._v(">")]), _vm._v(" came the reply.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("The voice did not sound like any human voice I had ever heard, either inside or outside my head. It was unique. "), _c('span', {
    staticClass: "span-symbols-sym"
  }, [_vm._v("<")]), _vm._v("Where are you?"), _c('span', {
    staticClass: "span-symbols-sym"
  }, [_vm._v(">")]), _vm._v(" I asked.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_c('span', {
    staticClass: "span-symbols-sym"
  }, [_vm._v("<")]), _vm._v("Lucifer Tower."), _c('span', {
    staticClass: "span-symbols-sym"
  }, [_vm._v(">")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("That sent a chill up my spine. Lucifer Tower was not a pressurized habitat—it was in the mysterious sensor array, at the leading edge of "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Olympia.")]), _vm._v(" Tech personnel no longer visited Lucifer Tower; it had its own repair drones. Yet something abided there, something with a voice that was almost machinelike—but not quite.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_c('span', {
    staticClass: "span-symbols-sym"
  }, [_vm._v("<")]), _vm._v("I would like to meet you,"), _c('span', {
    staticClass: "span-symbols-sym"
  }, [_vm._v(">")]), _vm._v(" I said. It wasn’t so impulsive a remark as it may seem.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Medusa touched me through the link. No one had ever been able to do that before. The secret part of my brain was stimulated, and I saw her face. She seemed too beautiful to be mortal, as if she were a mask. But then the mask spoke: "), _c('span', {
    staticClass: "span-symbols-sym"
  }, [_vm._v("<")]), _vm._v("Oichi, your parents are dead. "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Titania")]), _vm._v(" is gone."), _c('span', {
    staticClass: "span-symbols-sym"
  }, [_vm._v(">")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_c('span', {
    staticClass: "span-symbols-sym"
  }, [_vm._v("<")]), _vm._v("Destroyed by Baylor and Sheba Charmayne."), _c('span', {
    staticClass: "span-symbols-sym"
  }, [_vm._v(">")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_c('span', {
    staticClass: "span-symbols-sym"
  }, [_vm._v("<")]), _vm._v("I shall honor your parents’ wishes, and yours. We will collaborate."), _c('span', {
    staticClass: "span-symbols-sym"
  }, [_vm._v(">")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_c('span', {
    staticClass: "span-symbols-sym"
  }, [_vm._v("<")]), _vm._v("How?"), _c('span', {
    staticClass: "span-symbols-sym"
  }, [_vm._v(">")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_c('span', {
    staticClass: "span-symbols-sym"
  }, [_vm._v("<")]), _vm._v("I will come to you when the time is right."), _c('span', {
    staticClass: "span-symbols-sym"
  }, [_vm._v(">")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("I woke with a start. Had I fallen asleep and dreamed Medusa up?")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("I looked for the link again. I couldn’t find it.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Yet the pathway remained, and I traveled its length. Though it existed outside the known network, it could form links with that network at any juncture, then dissolve the link when the user was finished with it.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Medusa hid at the other end of that pathway. And she mentioned my parents. Had they known about her? How had she known about them? Was she one of the sophisticated machines Sheba and Baylor had talked about "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("killing")]), _vm._v("?")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Did they destroy "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Titania")]), _vm._v(" and kill two hundred thousand people—just to get rid of machines like her?")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_34",
      "title": "34"
    }
  }, [_vm._v("My heart had been a burning coal since my parents died. But the anger didn’t blind me; it gave me ideas about the secret link, my recordings of Sheba and Baylor, and possible uses for the biotech hidden inside my father’s music database. My new plans were beginning to take shape.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("But other people’s plans were already in motion. And they had quite a head start on me.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5755fa64","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter3.vue
// module id = 84
// module chunks = 0